import React, { useState, useRef, useEffect } from 'react'
import { graphql, Link } from 'gatsby'
import Mask from './Mask'
import linkResolver from '../utils/linkResolver'
import validateEmail from '../helpers/validateEmail'
import { addEmailToMailchimp } from '../services/Mailchimp'
import Player from '@vimeo/player'
import smoothScrollTo from '../helpers/smoothScrollTo'

const ERROR_EMAIL_FORMAT_INVALID = 'Email format invalid, please check again.'
const ERROR_EMAIL_EXIST = 'This email address is already in our mailing list.'
const ERROR_FROM_SERVER = 'There was an error with the server, please try again later.'
const SUCCESS_MESSAGE = 'Thanks for Subscribing!'

const Footer = ({ data, location }) => {

	const [email, setEmail] = useState('')
	const [error, setError] = useState(null)
	const [success, setSuccess] = useState(null)

	const handleEmailSubmit = () => {
		setSuccess(null)
		setError(null)
		if (validateEmail(email) === null) {
			setError(ERROR_EMAIL_FORMAT_INVALID)
		} else {
			addEmailToMailchimp(email)
			.then(res => {
				setSuccess(SUCCESS_MESSAGE)
			})
			.catch(err => {
				const errTitle = JSON.parse(err.response.text).title
				if (errTitle === 'Member Exists') {
					setError(ERROR_EMAIL_EXIST)
				} else {
					setError(ERROR_FROM_SERVER)
				}
			})
		}
	}

	const handleKeyPress = e => {
		if (e.key === 'Enter') {
			handleEmailSubmit()
		}
	}

	/**
	 * Video in the background
	 */
	 const videoContainerEl = useRef(null)
	 const playerVideo = useRef(null)

	 useEffect(() => {
		const options = {
			id: data.demo_vimeo_id,
			responsive: false,
			background: true,
			muted: true,
			playsinline: true,
			quality: localStorage.getItem('is-touch') === 'true' ? '720p' : 'auto'
		}

		playerVideo.current = new Player(videoContainerEl.current, {...options })

		playerVideo.current.ready().then(() => {
			playerVideo.current.play()
		})
	 }, [])

	const handleSolutionByClick = () => {
		if (location.pathname === '/solutions') {
			smoothScrollTo(null, 0, 0)
		}
	}

	return (
		<Mask speed={0.25}>
			<div className="Footer" data-menu-color="menu-white">
				<div className="Footer__Cta">
					<img
						className="Footer__CtaImage"
						src={data.demo_image.fluid.src}
						srcSet={data.demo_image.fluid.srcSet}
						alt={data.demo_image.alt}
					/>
					<div className="Footer__CtaVideo" ref={videoContainerEl}>
					</div>
					<h6 className="Footer__CtaTitle">Get In Touch</h6>
					<Link
						className="Footer__CtaText"
						to="/demo"
					>
						Request demo
					</Link>
				</div>
				<div className="Footer__Content">
					<div className="Footer__ContentTop">
						<div className="Footer__ContentTopLeft">
							<svg
								className="Footer__Logo"
								id="Layer_2" data-name="Layer 2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 780.36 203.86">
								<g id="Layer_1-2" data-name="Layer 1">
									<g>
										<path fillRule="evenodd;" d="M156.88,89.39l.02-38c0-.08-.01-.16-.02-.24l.02-47.72c0-1.88-1.07-3.41-2.39-3.41h-10.08c-.85-.02-1.65,.42-2.1,1.14l-9.55,15.07c-1.34,2.11-3.1,3.57-5.05,4.18L3.95,58.43C0,59.84,0,63.58,0,65.3v39.22c0,.07,.02,.14,.02,.21,0,0-.02,0-.02,0,0,0,0,5.39,0,6.85v49.65s0,0,0,0v39.22c0,1.88,1.08,3.4,2.4,3.4H12.49c.85,0,1.64-.44,2.1-1.16l9.54-15.09c1.34-2.11,3.1-3.58,5.05-4.19l124.96-39.3c.31-.1,.6-.28,.85-.53h.01c1.1-.35,1.88-1.73,1.88-3.33l.02-50.64c0-.14,0-.21-.02-.24Zm-127.7-1.9l110.94-34.89-7.86,12.41c-1,1.58-2.33,2.68-3.79,3.14L16.93,103.06l7.19-11.38c1.34-2.11,3.1-3.58,5.05-4.19Zm98.54,28.85L16.93,151.02l7.71-12.19c1-1.58,2.33-2.68,3.79-3.14l111.69-35.13-7.35,11.59c-1.34,2.11-3.1,3.57-5.05,4.18Z"/>
										<g>
											<path d="M247.36,169.35V16.69h62.81c9.6,0,18.06,1.93,25.41,5.78,7.34,3.85,13.09,9.27,17.23,16.25,4.14,6.98,6.22,15.27,6.22,24.86v3.05c0,9.45-2.15,17.7-6.43,24.75-4.29,7.05-10.11,12.51-17.45,16.36-7.34,3.85-15.67,5.78-24.97,5.78h-34.02v55.83h-28.79Zm28.79-82h31.19c6.83,0,12.36-1.89,16.57-5.67,4.21-3.78,6.32-8.94,6.32-15.48v-2.18c0-6.54-2.11-11.7-6.32-15.48-4.22-3.78-9.74-5.67-16.57-5.67h-31.19v44.49Z"/>
											<path d="M375.16,169.35V61.18h27.04v12.21h3.93c1.6-4.36,4.25-7.56,7.96-9.6,3.71-2.03,8.03-3.05,12.98-3.05h13.09v24.43h-13.52c-6.98,0-12.72,1.85-17.23,5.56-4.51,3.71-6.76,9.41-6.76,17.12v61.5h-27.48Z"/>
											<path d="M504.27,172.4c-10.76,0-20.43-2.18-29.01-6.54-8.58-4.36-15.34-10.69-20.28-18.97-4.94-8.29-7.41-18.24-7.41-29.88v-3.49c0-11.63,2.47-21.59,7.41-29.88,4.94-8.29,11.7-14.61,20.28-18.97,8.58-4.36,18.24-6.54,29.01-6.54s20.42,2.18,29,6.54c8.58,4.36,15.34,10.69,20.28,18.97,4.94,8.29,7.41,18.25,7.41,29.88v3.49c0,11.63-2.47,21.59-7.41,29.88-4.94,8.29-11.7,14.61-20.28,18.97-8.58,4.36-18.25,6.54-29,6.54Zm0-24.43c8.43,0,15.41-2.73,20.94-8.18,5.52-5.45,8.29-13.27,8.29-23.44v-2.18c0-10.18-2.73-17.99-8.18-23.44-5.45-5.45-12.47-8.18-21.05-8.18s-15.41,2.73-20.94,8.18c-5.53,5.45-8.29,13.27-8.29,23.44v2.18c0,10.18,2.76,17.99,8.29,23.44,5.52,5.45,12.5,8.18,20.94,8.18Z"/>
											<path d="M632.94,172.4c-10.76,0-20.43-2.18-29.01-6.54-8.58-4.36-15.34-10.69-20.28-18.97-4.94-8.29-7.41-18.24-7.41-29.88v-3.49c0-11.63,2.47-21.59,7.41-29.88,4.94-8.29,11.7-14.61,20.28-18.97,8.58-4.36,18.24-6.54,29.01-6.54s20.42,2.18,29,6.54c8.58,4.36,15.34,10.69,20.28,18.97,4.94,8.29,7.41,18.25,7.41,29.88v3.49c0,11.63-2.47,21.59-7.41,29.88-4.94,8.29-11.7,14.61-20.28,18.97-8.58,4.36-18.25,6.54-29,6.54Zm0-24.43c8.43,0,15.41-2.73,20.94-8.18,5.52-5.45,8.29-13.27,8.29-23.44v-2.18c0-10.18-2.73-17.99-8.18-23.44-5.45-5.45-12.47-8.18-21.05-8.18s-15.41,2.73-20.94,8.18c-5.53,5.45-8.29,13.27-8.29,23.44v2.18c0,10.18,2.76,17.99,8.29,23.44,5.52,5.45,12.5,8.18,20.94,8.18Z"/>
											<path d="M724.53,169.35V83.86h-27.48v-22.68h27.48v-20.06c0-7.41,2.22-13.34,6.65-17.77,4.43-4.43,10.21-6.65,17.34-6.65h28.35v22.68h-18.75c-4.07,0-6.11,2.18-6.11,6.54v15.27h28.35v22.68h-28.35v85.49h-27.48Z"/>
										</g>
									</g>
								</g>
							</svg>
							<p className="Footer__BackToTop" onClick={() => smoothScrollTo(null, 0, 0)}>Back to top</p>
						</div>
						<div className="Footer__ContentTopRight">
							<div className="Footer__Col">
								<p className="Footer__ColTitle">Products</p>
								<ul className="Footer__ColList">
									{data.products_links.map((link, index) => (
										<li
											className={`Footer__ColListItem ${link.has_margin_from_top ? 'hasMarginFromTop' : ''}`}
											key={`footer-col-list-product-link-${index}`}
										>
											<Link to={linkResolver(link.link_url)}>
												{link.link_label.text}
											</Link>
										</li>
									))}
								</ul>
							</div>
							<div className="Footer__Col">
								<p className="Footer__ColTitle">Solutions</p>
								<p className="Footer__ColSubtitle">Solutions by</p>
								<ul className="Footer__ColList">
									{data.solutions_sort_by.map((link, index) => (
										<li
											className="Footer__ColListItem"
											key={`footer-col-list-solution-link-${index}`}
										>
											<Link to={`/solutions?solution_type=${link.slug.replace(' ', '%20')}`} onClick={handleSolutionByClick}>
												{link.link_label.text}
											</Link>
										</li>
									))}
									{data.solutions_direct_links.map((link, index) => (
										<li
											className={`Footer__ColListItem ${index === 0 ? 'hasMarginFromTop' : ''}`}
											key={`footer-col-list-solution-link-direct-${index}`}
										>
											<Link to={linkResolver(link.link_url)}>
												{link.link_label.text}
											</Link>
										</li>
									))}
								</ul>
							</div>
							<div className="Footer__Col">
								<p className="Footer__ColTitle">Company</p>
								<ul className="Footer__ColList">
									{data.company_links.map((link, index) => (
										<li
											className="Footer__ColListItem"
											key={`footer-col-list-company-link-${index}`}
										>
											<Link to={linkResolver(link.link_url)}>
												{link.link_label.text}
											</Link>
										</li>
									))}
								</ul>
							</div>
						</div>
					</div>
					<div className="Footer__ContentBottom">
						<div className="Footer__ContentBottomLeft">
							<p className="Footer__Copyright">© Proof {new Date().getFullYear()}</p>
							<ul className="Footer__ContentBottomLinks">
								{data.bottom_links.map((link, index) => (
									<li
										className="Footer__ContentBottomLink"
										key={`footer-col-list-bottom-link-${index}`}
									>
										{link.link_url.link_type === 'Web' &&
											<a href={link.link_url.url} target="_blank">
												{link.link_label.text}
											</a>
										}
										{link.link_url.link_type === 'Document' &&
											<Link to={linkResolver(link.link_url)}>
												{link.link_label.text}
											</Link>
										}
									</li>
								))}
							</ul>
						</div>
						<div className="Footer__ContentBottomRight">
							<p className="Footer__NewsletterTitle">Newsletter</p>
							<div className="Footer__NewsletterContainer">
								<div className={`Footer__NewsletterRoller ${success ? 'showMessage' : ''}`}>
									<div className="Footer__NewsletterInputWrapper">
										<input
											className="Footer__NewsletterInput"
											type="email"
											placeholder="Email Address"
											value={email}
											onChange={e => setEmail(e.target.value)}
											onKeyPress={handleKeyPress}
										/>
										<svg onClick={handleEmailSubmit} className="Footer__NewsletterArrow" viewBox="0 0 39 39"><g strokeWidth="5" fill="none" fillRule="evenodd"><path d="M8.138 3h28.12v27.894M2 36.953 36.258 3"/></g></svg>
									</div>
									<p className="Footer__NewsletterSuccess">{success}</p>
								</div>
							</div>
							{error &&
								<p className="Footer__NewsletterError">{error}</p>
							}
						</div>
					</div>
				</div>
			</div>
		</Mask>
	)
}

export default Footer

export const query = graphql`
	fragment Footer on PrismicFooter {
		data {
			demo_title {
				text
			}
			demo_text {
				text
			}
			demo_vimeo_id
			demo_image {
				alt
				fluid {
					src
					srcSet
				}
			}
			products_links {
        link_url {
          type
					link_type
					url
					uid
        }
        link_label {
          text
        }
        has_margin_from_top
      }
			solutions_sort_by {
        slug
        link_label {
          text
        }
      }
			solutions_direct_links {
				link_url {
          type
					link_type
					url
					uid
        }
        link_label {
          text
        }
			}
			company_links {
        link_url {
          type
					link_type
					url
					uid
        }
        link_label {
          text
        }
      }
			bottom_links {
        link_url {
          link_type
          type
          url
					uid
        }
        link_label {
          text
        }
      }
		}
	}
`